import Enumeration from '../../../../../../foundation/enumeration/Enumeration';

export default class OrganizationType extends Enumeration {

	public static readonly BUSINESS = 'BUSINESS';
	public static readonly SCHOOL = 'SCHOOL';

	protected getPossibleValues () {
		return [OrganizationType.BUSINESS, OrganizationType.SCHOOL];
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/organizations/domain/aggregates/organization/OrganizationType.ts